import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { EntityImportValidationError } from "@idw-types/data/entity-import-validation-error";

export const validateVerificationServiceRequest = async (
    body: { [key: string]: any }
): Promise<{ data: Array<EntityImportValidationError>, error: any }> => {
    const route = apiRoutes.serviceConfiguration.rpServiceConfig.validate;
    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error };
};